import { GetUrl } from "../config/GetUrl";

const url =
  String(GetUrl.API_URL).replace(/\/+$/, "") +
  "/api/v1/Admin/checkout-settings";

async function request(method, data) {
  const token = localStorage.getItem("tokenAdmin");

  if (!token) {
    throw new Error("Admin session expired. Please log in again.");
  }

  const response = await fetch(
    "https://api.galaxylabsnyc.com/api/v1/Admin/checkout-settings",
    {
    method,
    cache: "no-store",
    headers: {
      authorization: `Bearer ${token}`,
      ...(data ? { "Content-Type": "application/json" } : {})
    },
    ...(data ? { body: JSON.stringify(data) } : {})
    }
  );

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.error || "Unable to update settings");
  }

  return result;
}

export const getCheckoutSettings = () => request("GET");

export const saveCheckoutSettings = (data) =>
  request("PUT", data);
